// Exemple de script de page, add it to $additional_bottom_scripts = []; on the  page


    // Init Skrollr
    skrollr.init({
        smoothScrolling: true,
        smoothScrollingDuration: 500,
        mobileDeceleration: 0.004,
        forceHeight: true,
        render: function(data) {
            //Debugging - Log the current scroll position.
            //console.log(data.curTop);
        },
       
    });

    var _skrollr = skrollr.get(); // get() returns the skrollr instance or undefined
    var windowWidth = $(window).width();

    if ( windowWidth <= 640 && _skrollr !== undefined ) {
      _skrollr.destroy();
    }
   

